import httpClient from '../utils/http'
import _ from 'lodash';
import { handleResponseAsync } from '../utils/HelperUtils';

export const actionService = {
  fetchActionTypes
};

function fetchActionTypes() {
  const url = '/api/actionType';

  // const config = {
  //   headers: {
  //     'content-type': 'application/json'
  //   }
  // };

  return httpClient
    .get(url)
    .then(handleResponseAsync)
    .then(res => res.data);
}
